import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { addResourceCategory } from '../../actions/categories';
import { isAdding } from '../../../entityManagement/selectors';
import { stopEntityAdding } from '../../../entityManagement/actions';
import { SimpleResourceCategory } from '../../types';
import categoryFormFactory from './categoryFormFactory';

interface StateProps {
    opened: boolean;
}

interface OwnProps {
    id: string;
    scope: string;
}

const CategoryAddFormHelper = categoryFormFactory({ headerButtonTextKey: TextKey.NewSpaceCategory });

export default connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        opened: isAdding,
    }),
    (dispatch: CommanderThunkDispatch, { scope }) => ({
        onSubmit: (values: SimpleResourceCategory) => {
            dispatch(stopEntityAdding(scope));
            dispatch(addResourceCategory(values));
        },
        onClose: () => dispatch(stopEntityAdding(scope)),
    })
)(CategoryAddFormHelper);
